import React, { useState, useEffect } from "react";
import BasicRouter from "./BasicRouter";
import UserEntry from "./components/header/UserEntry";
import "./App.scss";
import { loginPost, loginToken } from "./server/Customer";
import { getCategoriesByDepth } from "./server/Category";
import { getCart } from "./server/CollectSite";
import { setToggleCart } from "./server/CartsOpen";
import { useSelector, useDispatch } from "react-redux";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Preload from "./components/Preload";
import OpenText from "./components/OpenText";
import { customerList, customerListClear } from "./server/ShoppingList";
import { SystemMessagePopUp } from "./components/containers/PopUp";
import { useLocation, useNavigate } from "react-router-dom";
import UserResetEmail from "./components/header/UserEmailReset";
import { GetShippingAddress } from "./server/ShippingAddress";
import PopAddress from "./components/routs/address/PopAddress";
import ProductPageWithImg from "./components/routs/productPage/ProductPageWithImg";
import HeaderConnection from "./components/header/HeaderConnection";
import AdminDashboard from "./components/routs/adminDashboard/AdminDashboard";

const App = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userEntry, user, preload, role, userHaveReset, stationId } =
    useSelector((state) => ({
      user: state.user.user,
      role: state.user.role,
      userEntry: state.user.userEntry,
      preload: state.openCart.preload,
      userHaveReset: state.user.userHaveReset,
      stationId: state.user.stationId,
    }));

  const [canPay, setCanPay] = useState(true);
  const [startPopUp, setStartPopUp] = useState(true);
  const [currentSubCategory, setCurrentSubCategory] = useState(null);
  const [showStationPopUp, setShowStationPopUp] = useState(true);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [adminToCustomer, setAdminToCustomer] = useState(null);
  const [allProduct, setAllProduct] = useState(true);

  useEffect(() => {
    getToken();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (!user) {
      dispatch(setToggleCart(false));
      dispatch(customerListClear());
    } else {
      getProducts();
      if (role) {
        dispatch(customerListClear());
      } else {
        //dispatch(customerList());
      }
      if (user?.id) {
        setShippingAddress(user);
      }
    }
  }, [user]);

  const getToken = () => {
    if (!localStorage.getItem("jwtToken")) {
      haveGetToken();
    } else {
      dispatch(loginPost(false));
    }
  };

  // const haveGetToken = () => {
  //   const val = {
  //     userName: "xxx",
  //     password: "1258",
  //     grant_type: "password",
  //   };
  //   dispatch(loginToken(val, false));
  // };
  const haveGetToken = () => {
    console.log("Checking login... userHaveReset status:", userHaveReset); // לוג לבדיקה
    if (userHaveReset) {
      console.log("Login blocked by userHaveReset");
      return;
    }

    const val = {
      userName: "guest",
      password: "a1234567",
      grant_type: "password",
    };
    console.log("Dispatching loginToken with guest credentials");
    dispatch(loginToken(val, false));
  };

  const getProducts = () => {
    if (!role) {
      dispatch(getCart(stationId));
    }
  };

  const [productPopUp, setProductPopUp] = useState(false);
  const [selectedProd, setSelectedProd] = useState(null);
  const [pendingScrollSlug, setPendingScrollSlug] = useState(null);

  if (pathname.startsWith("/admin") && role) {
    return (
      <div className="admin-mode">
        <div className="header-wrapper">
          <HeaderConnection
            setAllProduct={setAllProduct}
            setAdminToCustomer={setAdminToCustomer}
            user={user}
            role={role}
            stationId={stationId}
            basicHeader={true}
            haveGetToken={haveGetToken}
          />
        </div>
        <AdminDashboard />
        {preload ? <Preload /> : null}
        <BasicRouter
          allProduct={allProduct}
          adminToCustomer={adminToCustomer}
          canPay={canPay}
          closePayPopup={() => setCanPay(false)}
          setCurrentSubCategory={setCurrentSubCategory}
          currentSubCategory={currentSubCategory}
          setProductPopUp={setProductPopUp}
          setSelectedProd={setSelectedProd}
        />
      </div>
    );
  }

  return (
    <div>
      {showStationPopUp &&
      user &&
      !role &&
      //user?.StationId &&
      user?.UserTypeId !== 5 ? (
        <PopAddress
          setShowStationPopUp={setShowStationPopUp}
          shippingAddress={shippingAddress}
        ></PopAddress>
      ) : null}
      {startPopUp && !role && (!showStationPopUp || user?.UserTypeId === 5) ? (
        <SystemMessagePopUp width="500px" close={() => setStartPopUp(false)}>
          <OpenText ShowHome={false} />
        </SystemMessagePopUp>
      ) : null}
      <Header
        setAllProduct={setAllProduct}
        setAdminToCustomer={setAdminToCustomer}
        currentSubCategory={currentSubCategory}
        haveGetToken={haveGetToken}
        setProductPopUp={setProductPopUp}
        setSelectedProd={setSelectedProd}
        setPendingScrollSlug={setPendingScrollSlug}
      />
      {preload ? <Preload /> : null}
      <main>
        <BasicRouter
          allProduct={allProduct}
          adminToCustomer={adminToCustomer}
          canPay={canPay}
          closePayPopup={() => setCanPay(false)}
          setCurrentSubCategory={setCurrentSubCategory}
          currentSubCategory={currentSubCategory}
          setProductPopUp={setProductPopUp}
          setSelectedProd={setSelectedProd}
          pendingScrollSlug={pendingScrollSlug}
          setPendingScrollSlug={setPendingScrollSlug}
        />
      </main>
      {productPopUp && (
        <ProductPageWithImg
          selectedProd={selectedProd}
          close={() => setProductPopUp(false)}
        />
      )}
      <Footer />
      {userHaveReset ? (
        <UserResetEmail
          Email={userHaveReset.email}
          Password={userHaveReset.password}
          customerId={userHaveReset.customerId}
          emailPassword={userHaveReset.passwordMail}
        />
      ) : null}
      {!userHaveReset && userEntry[0] && !pathname.includes("reset/") ? (
        <UserEntry typeOfUser={userEntry[1]} />
      ) : null}
    </div>
  );
};

export default App;
